/** Who wrote a ticket message: the company's staff, Pauly (an admin), or the system itself. */
export enum ServiceDeskMessageSide {
  Company = 0,
  Pauly = 1,
  System = 2,
}
